import * as React from 'react';

const LocationArrow16 = ({ title, titleId, ...props }) => /* @__PURE__ */ React.createElement("svg", { fill: "none", viewBox: "0 0 16 16", width: 16, height: 16, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M12.71 2.543 2.843 6.75c-.165.07-.23.156-.263.223-.04.083-.06.2-.034.329a.53.53 0 0 0 .157.292c.057.05.15.106.33.11l2.567.072c1.355.038 2.444 1.1 2.482 2.42l.084 2.843c.005.182.063.272.109.322a.46.46 0 0 0 .252.134c.11.02.206.004.276-.029.055-.027.14-.085.214-.25.503-1.14 1.008-2.29 1.514-3.442a931 931 0 0 1 2.885-6.524.5.5 0 0 0-.12-.591.51.51 0 0 0-.586-.117ZM2.228 5.38l9.867-4.208c1.72-.734 3.479 1 2.726 2.677a927 927 0 0 0-2.877 6.506c-.506 1.153-1.013 2.306-1.519 3.451-.856 1.938-3.73 1.384-3.793-.724L6.55 10.24a1.01 1.01 0 0 0-.993-.968L2.99 9.2C.807 9.14.228 6.234 2.228 5.381Z"
  }
));
LocationArrow16.Size = 16;
LocationArrow16.Title = "LocationArrow";

export { LocationArrow16 as default };
